module.exports = __webpack_public_path__ + "static/media/arrow-icon.8e971e3e.svg";